import { SvgCut, TextButton } from '@loomhq/lens';
import React, { Component } from 'react';

import ActionDot, { TOP_LEFT } from 'components/ui-components/action-dot';

import './styles.less';

class EndCurrentTrimButton extends Component {
  render() {
    return (
      <div className="trim-bar-end-current-trim-range-button">
        {this.props.showActionDot && <ActionDot position={TOP_LEFT} />}
        <TextButton
          icon={<SvgCut />}
          onClick={this.props.onEndCurrentTrimRange}
        >
          Remove
        </TextButton>
      </div>
    );
  }
}

export default EndCurrentTrimButton;
